import { dspConfig } from "@beatbox/voice-core";
export const DEFAULT_VAD_CONFIG = {
    enterGate: null,
    exitRatio: 0.6,
    minDurationMs: 120,
    hangoverMs: 220,
    maxDurationMs: 4000,
    preRollMs: 150,
};
export class UtteranceCutter {
    constructor(cfg = {}) {
        Object.defineProperty(this, "cfg", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "idle"
        });
        Object.defineProperty(this, "onset", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "lastVoiced", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        this.cfg = { ...DEFAULT_VAD_CONFIG, ...cfg };
    }
    setConfig(patch) {
        this.cfg = { ...this.cfg, ...patch };
    }
    getConfig() {
        return { ...this.cfg };
    }
    get active() {
        return this.state !== "idle";
    }
    /** Drop any in-progress utterance (e.g. while replaying audio). */
    reset() {
        this.state = "idle";
    }
    feed(tMs, energy) {
        const enter = this.cfg.enterGate ?? dspConfig.energyGate;
        const exit = enter * this.cfg.exitRatio;
        switch (this.state) {
            case "idle":
                if (energy > enter) {
                    this.state = "speaking";
                    this.onset = tMs;
                    this.lastVoiced = tMs;
                }
                return null;
            case "speaking":
                if (energy > exit)
                    this.lastVoiced = tMs;
                else
                    this.state = "hangover";
                if (tMs - this.onset >= this.cfg.maxDurationMs) {
                    return this.finalize(tMs);
                }
                return null;
            case "hangover":
                if (energy > enter) {
                    this.state = "speaking";
                    this.lastVoiced = tMs;
                    if (tMs - this.onset >= this.cfg.maxDurationMs) {
                        return this.finalize(tMs);
                    }
                    return null;
                }
                if (tMs - this.lastVoiced >= this.cfg.hangoverMs) {
                    return this.finalize(this.lastVoiced);
                }
                return null;
        }
    }
    /** Force-close a pending utterance (e.g. at session end). */
    flush(tMs) {
        if (this.state === "idle")
            return null;
        return this.finalize(Math.min(tMs, Math.max(this.lastVoiced, this.onset)));
    }
    finalize(endMs) {
        const t0 = Math.max(0, this.onset - this.cfg.preRollMs);
        const spoken = endMs - this.onset;
        this.state = "idle";
        if (spoken < this.cfg.minDurationMs)
            return null;
        return { t0, t1: endMs };
    }
}
